/*
  // Init: 
  const notification = new Notification({
    containerClass: "notify",
    itemClass: "notify__item",
    timeout: 10000,
    mods: {
      hidden: 'notify__item--hidden',
      error: 'notify__item--error'
    },
  });
  // Example:
  notification.add('Notification example', ["error"]);
*/

class Notification {
  constructor({
    containerClass = 'notify',
    itemClass = 'notify__item',
    mods = {},
    timeout = 3000,
  } = {}) {
    this.containerClass = containerClass;
    this.itemClass = itemClass;
    this.mods = mods;
    this.timeout = timeout;
    this.container = null;
  }

  ensureContainer() {
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.className = this.containerClass;
      document.body.appendChild(this.container);
    }
  }

  add(text, mods=[]) {
    if(!text) return;
    this.ensureContainer();

    const item = document.createElement('div');
    item.className = this.itemClass;
    mods.forEach(mod => {
      const cls = this.mods[mod];
      cls && item.classList.add(cls);
    });
    item.classList.add(this.mods.hidden || "");
    
    const textBlock = document.createElement('p');
    textBlock.className = `${this.containerClass}__text`;
    textBlock.textContent = text;
    item.appendChild(textBlock);

    const close = document.createElement('button');
    close.className = `${this.containerClass}__close`;
    close.textContent = '×';
    close.onclick = () => this.remove(item);
    item.appendChild(close);

    this.container.appendChild(item);
    setTimeout(()=>{
      item.classList.remove(this.mods.hidden || "");
      setTimeout(() => this.remove(item), this.timeout);
    }, 100);
  }

  remove(item) {
    const hiddenClass = this.mods.hidden || `${this.itemClass}--hidden`;
    item.classList.add(hiddenClass);

    const removeFromDOM = () => {
      item.remove();
      if (this.container && !this.container.children.length) {
        this.container.remove();
        this.container = null;
      }
    };

    item.addEventListener('transitionend', removeFromDOM, { once: true });
    setTimeout(removeFromDOM, 5000);
  }
}

export default Notification;